import React from 'react';
import AppRoutes from './route/AppRoutes';
import Footer from '../src/components/footer/footer';
import { BrowserRouter as Router } from "react-router-dom";
import { useKeycloakState } from './Context/KeycloakContext';
import { AppContextProvider } from "./Context/AppContext";

const App = () => {
  const { keycloackValue } = useKeycloakState();

  // Prevent rendering until Keycloak initializes
  if (keycloackValue === null) {
    return null; 
  }

  return (
    <Router>
       <AppContextProvider>
      <AppRoutes />
      <Footer />
      </AppContextProvider>
    </Router>
  );
};

export default App;